import Vue from "vue"
import Vuex from "vuex"
import { getChildrenArticleById } from "@/api/blog.js"
import { languageMap } from "../data/list"

Vue.use(Vuex)
let blogList = []

function getBlogList(data, targetstr) {
  data.forEach((child) => {
    child.name = child.name.replace(/replacestr1024/g, targetstr)
  })
  data.forEach((item) => {
    item.articleList.forEach((child) => {
      child.title = child.title.replace(/replacestr1024/g, targetstr)
    })
    item.articleList && (blogList = [...blogList, ...item.articleList])
    item.childrenList && getBlogList(item.childrenList, targetstr)
  })
}

// function getLangFromHash() {
//   const hash = window.location.hash // "#/?lang=en"
//   const search = hash.split("?")[1] || "" // "lang=en"
//   const params = new URLSearchParams(search)
//   // const langMap = {
//   //   zh: "chinese",
//   //   en: "english",
//   // }
//   const lang = params.get("lang")
//   return lang
// }
// // 优先采用路径参数（Funlink跳转），若无则采用本地存储，若无则默认为中文
// const savedLanguage =
//   getLangFromHash() || localStorage.getItem("selectedLanguage") || "zh"

export default new Vuex.Store({
  state: {
    // 平台名
    title: "",
    // 注册Icon地址
    registerIcon: "",
    // 登录Icon地址
    loginIcon: "",
    // 主页icon地址
    indexIcon: "",
    // 页头icon地址
    headerIcon: "",
    currentBlogId: "",
    currentEnglishBlogId: "",
    currentColumnId: localStorage.getItem("currentColumnId") || "",
    menutree: [], // 菜单树结构
    menulist: [], // 拍平后的菜单列表
    selectedLanguage: 'zh', // 接口传参 1中文 2英文
    texts: languageMap['zh']?.text,
  },
  mutations: {
    SET_TITLE: (state, title) => {
      state.title = title
    },
    SET_REGISTERICON: (state, url) => {
      state.registerIcon = url
    },
    SET_LOGINICON: (state, url) => {
      state.loginIcon = url
    },
    SET_INDEXICON: (state, url) => {
      state.indexIcon = url
    },
    SET_HEADERICON: (state, url) => {
      state.headerIcon = url
    },
    SET_MENUTREE: (state, tree) => {
      state.menutree = tree
    },
    SET_MENULIST: (state, list) => {
      state.menulist = list
    },
    SET_CURRENTBLOG: (state, id) => {
      state.currentBlogId = id
    },
    SET_CURRENTENGLISHBLOG: (state, id) => {
      state.currentEnglishBlogId = id
    },
    SET_CURRENTCOLUMN: (state, id) => {
      state.currentColumnId = id
      localStorage.setItem("currentColumnId", id)
    },
    SET_TEXTS: (state, type) => {
      state.texts = languageMap[type]?.text
      state.selectedLanguage = type
      localStorage.setItem("selectedLanguage", type)
    },
  },
  actions: {
    async setWebInfo({ commit, state }, { data, language }) {
      commit("SET_TITLE", data.headerName)
      commit("SET_REGISTERICON", data.registerIcon)
      commit("SET_LOGINICON", data.loginIcon)
      commit("SET_INDEXICON", data.indexIcon)
      commit("SET_HEADERICON", data.headerIcon)
      const resp = await getChildrenArticleById({
        id: languageMap[language].id,
      })
      resp.data.childrenList.forEach((item) => {})
      commit("SET_MENUTREE", resp.data.childrenList)

      await getBlogList(resp.data.childrenList, data.headerName)
      commit("SET_MENULIST", blogList)
      // let link = document.createElement("link")
      // link.rel = "icon"
      // link.href = data.headerIcon
      // document.head.appendChild(link)
      document.title =
        state.selectedLanguage === "en"
          ? "Funlink-Help center"
          : "Funlink-帮助中心"
    },
  },
  modules: {},
})
